import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M19 5h-5v7l5 6zm-9 13v-6l-5 6z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 3h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-2h-2v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1zm-2 17H5l5-6v6z"
})), 'CompareTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CompareTwoTone.js
// module id = 2907
// module chunks = 2